import { Checkbox } from "./checkbox.tsx";
import { cn } from "../lib/utils.ts";

// Presentational skill list primitives. Interactive behavior (edit/delete
// buttons, tRPC mutations) stays in the add-in; the marketing mockup renders
// SkillRow with `interactive={false}` so it looks identical without wiring
// any handlers.

export type SkillRowData = {
  name: string;
  description: string;
  slug: string;
};

export function SkillGroupHeader({
  label,
  className,
}: {
  label: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "text-[10px] uppercase tracking-wider text-[var(--color-muted-foreground)] px-1.5",
        className,
      )}
    >
      {label}
    </div>
  );
}

export function SkillRow({
  skill,
  pinned,
  onToggle,
  actions,
  interactive = true,
}: {
  skill: SkillRowData;
  pinned: boolean;
  onToggle?: () => void;
  actions?: React.ReactNode;
  interactive?: boolean;
}) {
  const label = (
    <>
      <Checkbox
        checked={pinned}
        onCheckedChange={onToggle ? () => onToggle() : undefined}
        className="mt-0.5"
        disabled={!interactive}
      />
      <div className="flex flex-col gap-0.5 min-w-0">
        <div className="text-xs font-medium leading-tight truncate">
          {skill.name}
        </div>
        {skill.description && (
          <div className="text-[11px] leading-snug text-[var(--color-muted-foreground)] line-clamp-2">
            {skill.description}
          </div>
        )}
        <div className="text-[10px] font-mono text-[var(--color-muted-foreground)]">
          {skill.slug}
        </div>
      </div>
    </>
  );

  return (
    <div
      className={cn(
        "group flex items-start gap-2 rounded-md px-1.5 py-1",
        interactive && "hover:bg-[var(--color-secondary)]",
      )}
    >
      {interactive ? (
        <label className="flex flex-1 min-w-0 items-start gap-2 cursor-pointer">
          {label}
        </label>
      ) : (
        <div className="flex flex-1 min-w-0 items-start gap-2">{label}</div>
      )}
      {actions}
    </div>
  );
}
